import { getAPIN8N } from "@/services/Api/n8nApiConfig";

export function useRefundPOS() {
    const N8N_API = getAPIN8N("fcc986f3-597e-4a43-ba78-cd8f9a8fa908");

    const createRefund = (uuid: string, data: any) => {
        return N8N_API.patch(`charges/${uuid}/pos/refunds`, data);
    }

    const getRefund = (uuid: String) => {
        return N8N_API.get(`charges/${uuid}/pos/refunds`,);
    }

    return {
        createRefund,
        getRefund
    };
}